import { motion } from "framer-motion";

export default function ProgressRing({
    value = 0,
    size = 180,
    stroke = 14,
    label,
    sublabel,
    color = "#EE722E",
    trackColor = "rgba(255,255,255,0.06)",
    children,
}) {
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const clamped = Math.max(0, Math.min(100, value));
    const offset = circumference - (clamped / 100) * circumference;

    return (
        <div className="relative inline-flex items-center justify-center">
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                className="-rotate-90"
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={trackColor}
                    strokeWidth={stroke}
                />
                <motion.circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    initial={{ strokeDashoffset: circumference }}
                    animate={{ strokeDashoffset: offset }}
                    transition={{ duration: 1.4, ease: "easeOut" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                {children ? (
                    children
                ) : (
                    <>
                        <span className="text-3xl sm:text-4xl font-extrabold text-white">
                            {Math.round(clamped)}
                            <span className="text-lg text-white/60">%</span>
                        </span>
                        {label && (
                            <span className="text-xs font-thin tracking-[0.2em] text-shariti-orange-light uppercase mt-1">
                                {label}
                            </span>
                        )}
                        {sublabel && (
                            <span className="text-xs text-white/50 mt-0.5">{sublabel}</span>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
